import React from "react";
import { createRoot } from "react-dom/client";
import { Provider, useSelector } from "react-redux";
import { store, selectIsLoading } from "./store/store";
import Loader from "./components/Loader/Loader";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Realizations from "./posts/Realizations/Realizations";

const GlobalLoader = () => {
    const isLoading = useSelector(selectIsLoading);

    return <Loader loading={isLoading} fullscreen={true} />;
};

document.addEventListener("DOMContentLoaded", () => {
    const headerRoot = document.getElementById("header");
    const footerRoot = document.getElementById("footer");
    const realizationsRoot = document.getElementById("realizations");

    const renderComponent = (rootElement, Component) => {
        if (rootElement) {
            const root = createRoot(rootElement);
            root.render(
                <React.StrictMode>
                    <Provider store={store}>
                        <GlobalLoader />
                        <Component />
                    </Provider>
                </React.StrictMode>
            );
        }
    };

    // Renderowanie Header i Footer
    renderComponent(headerRoot, Header);
    renderComponent(footerRoot, Footer);

    // Renderowanie Realizations tylko na podstronie
    if (realizationsRoot) {
        renderComponent(realizationsRoot, Realizations);
    }
});
